"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var config_1 = __importStar(require("../../config"));
var api_1 = require("../../utils/api");
var getUserAttributes_1 = __importDefault(require("./queries/getUserAttributes"));
var constants_1 = require("./constants");
// eslint-disable-next-line import/prefer-default-export
exports.fetchUserAttributes = function () {
    return api_1.createApiAction(constants_1.FETCH_USER_ATTRIBUTES, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getUserAttributes_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
//# sourceMappingURL=actions.js.map